// @flow
import * as ActionTypes from 'action_types/HomeActionTypes';
import { PHOTOSHOOTING_SAVED } from 'action_types/MeeroAppointmentActionTypes';
import Dispatcher from 'dispatcher';
import Asset from 'models/homes/Asset';
import _ from 'lodash';
import { Store } from '@homie/flux';

const CHANGE = 'change';
let _home_onboarding = {};
let _assets = {};
let _acceptedAssets = {};
let _declinedAssets = {};
let _metadata = {};
class HomeOnboardingStore extends Store {
  constructor(): void {
    super();
    Dispatcher.register(this._actionsHandler);
  }

  getHome = () => {
    return _home_onboarding;
  };
  _deleteAsset = (asset_id: string, asset_type: string) => {
    const assetsIds = _assets[asset_type].map(asset => asset.id);
    const acceptedIds = _acceptedAssets[asset_type].map(asset => asset.id);
    const declinedIds = _declinedAssets[asset_type].map(asset => asset.id);
    if (assetsIds.indexOf(asset_id) > -1) {
      _assets[asset_type].splice(assetsIds.indexOf(asset_id), 1);
    }
    if (acceptedIds.indexOf(asset_id) > -1) {
      _acceptedAssets[asset_type].splice(acceptedIds.indexOf(asset_id), 1);
    }
    if (declinedIds.indexOf(asset_id) > -1) {
      _declinedAssets[asset_type].splice(declinedIds.indexOf(asset_id), 1);
    }
  };
  _addTrueAsset = (temp_asset_id: string, asset: Asset) => {
    if (_assets[asset.asset_type] && _assets[asset.asset_type].length > 0) {
      for (let i = 0; i < _assets[asset.asset_type].length; ++i) {
        if (_assets[asset.asset_type][i].id === temp_asset_id) {
          _assets[asset.asset_type][i] = asset;
          break;
        }
      }
    } else {
      _assets[asset.asset_type] = [asset];
    }
  };
  _addTempAsset = (asset: Asset) => {
    if (_assets[asset.asset_type]) {
      _assets[asset.asset_type].push(asset);
    } else {
      _assets[asset.asset_type] = [asset];
    }
  };
  getAssetsByType = (asset_type: string) => {
    return _assets[asset_type] || [];
  };
  getAcceptedAssetsByType = (asset_type: string) => {
    return _acceptedAssets[asset_type] || [];
  };
  getDeclinedAssetsByType = (asset_type: string) => {
    return _declinedAssets[asset_type] || [];
  };
  getAllAssets = (asset_type: string) => {
    return _assets;
  };

  getMetadata = (): any => {
    return _metadata;
  };

  _setHome = home_onboarding => {
    _home_onboarding = home_onboarding;
  };
  _setAssetsHome = (
    asset_type: string,
    assets: Array<Asset>,
    accepted: Array<Asset>,
    declined: Array<Asset>
  ) => {
    const acceptedIds = accepted.map(asset => asset.id);
    const declinedIds = declined.map(asset => asset.id);
    const unapproveds = assets.filter(function(e) {
      return (
        declinedIds.indexOf(e.id) === -1 && acceptedIds.indexOf(e.id) === -1
      );
    });
    _assets[asset_type] = unapproveds;
    _acceptedAssets[asset_type] = accepted;
    _declinedAssets[asset_type] = declined;
  };

  _setMetadata = (metadata: {}) => {
    _metadata = _.assign(_metadata, metadata);
  };

  _setPhotoshooting = (photoshooting: any) => {
    _home_onboarding.photoshooting = photoshooting;
  };

  _emitChange = () => {
    this.emit(CHANGE);
  };

  addChangeListener = (callback: () => void) => {
    this.on(CHANGE, callback);
  };

  removeChangeListener = (callback: () => void) => {
    this.removeListener(CHANGE, callback);
  };

  _actionsHandler = (action: any) => {
    switch (action.type) {
      case ActionTypes.EDIT_HOME_ONBOARDING:
      case ActionTypes.UPDATE_HOME_ONBOARDING:
      case ActionTypes.CREATE_SIMILAR_HOME_ONBOARDING:
      case ActionTypes.CREATE_HOME_ONBOARDING: {
        this._setHome(action.home);
        this._setMetadata(action.metadata);
        this._emitChange();
        break;
      }
      case ActionTypes.LIST_HOME_ASSETS: {
        this._setAssetsHome(
          action.asset_type,
          action.assets,
          action.accepted,
          action.declined
        );
        this._emitChange();
        break;
      }
      case ActionTypes.DELETE_HOME_ASSET: {
        this._deleteAsset(action.asset_id, action.asset_type);
        this._emitChange();
        break;
      }
      case ActionTypes.ADD_TEMP_HOME_ASSET: {
        this._addTempAsset(action.asset);
        this._emitChange();
        break;
      }
      case ActionTypes.UPLOAD_HOME_ASSET: {
        this._addTrueAsset(action.temp_asset_id, action.asset);
        this._emitChange();
        break;
      }
      case PHOTOSHOOTING_SAVED: {
        this._setPhotoshooting(action.photoshooting);
        break;
      }
    }
    this.notify();
  };
}

export default new HomeOnboardingStore();
